import React from 'react';

import DashboardContainer from '../../components/admin/DashboardContainer'
import StudentsList from '../../components/admin/StudentsList'
import MojoHelpdeskWidget from '../../components/admin/HelpdeskWidget'

export default function Support() {
  return (
    <DashboardContainer title={'Soporte'}>
      <MojoHelpdeskWidget/>
    </DashboardContainer>
  );
}
